import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactSection = () => {
  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-primary/10 border border-primary/20 rounded-lg p-8 text-center">
          <Icon name="HelpCircle" size={32} color="var(--color-primary)" className="mx-auto mb-4" />
          <h3 className="text-2xl font-heading font-semibold text-foreground mb-2">
            Kontaktieren Sie uns
          </h3>
          <p className="text-muted-foreground mb-6">
            Haben Sie Fragen zur THG-Prämie oder möchten Sie mehr über unsere Dienstleistungen erfahren? Unser Team steht Ihnen gerne zur Verfügung.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <a
              href="tel:+4915223152476"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth"
            >
              <Icon name="Phone" size={18} />
              +49 152 231 524 76
            </a>
            <a
              href="mailto:oliver.wagner@gridbalance.de"
              className="inline-flex items-center gap-2 px-6 py-3 bg-card text-foreground border border-border rounded-lg hover:bg-muted transition-smooth"
            >
              <Icon name="Mail" size={18} />
              oliver.wagner@gridbalance.de
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Icon name="Globe" size={16} color="var(--color-primary)" />
            <a
              href="https://www.gridbalance.de"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition-smooth"
            >
              www.gridbalance.de
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;